<div class="motion-distraction">
  <div class="secondary-rect"></div>
  <div class="primary-rect"></div>
  <svg class="distractor-brand" version="1.1" width="100" height="100" viewBox="0 0 100 100">
    <g>
      <g>
        <path
          class="secondary-fill"
          d="M54.9,37.9H20.1l-2.7,5h37.5c1.8,0,1.9-1.9,1.9-2.5C56.8,38.7,56,37.9,54.9,37.9z"
        />
        <path
          class="primary-fill"
          d="M64.8,55.6c6.3-2.3,9.4-7.2,9.4-14.6v-1.6c0-2.2-0.3-4.3-0.9-6.1c-0.6-1.9-1.5-3.5-2.8-4.9
                          c-1.3-1.4-3-2.5-5-3.3c-2-0.8-4.5-1.2-7.3-1.2H30.7L28.4,28h7.9V31h-9.9l-2.3,4.1h11.6h0.6h10.9v-2.5H56c4.8,0,7.3,2.4,7.3,7.2V41
                          c0,2.4-0.6,4.1-1.8,5.4c-1.2,1.2-3.1,1.8-5.7,1.8h-8.6v-2.7l-20.8,0l-2.3,4.1h12.2v3.1h-5.6l-2.3,4.1h7.9v19.3h10.9V56.9h7
                          l9.7,19.3h12.2L64.8,55.6z"
        />
      </g>
    </g>
  </svg>
  <h4 class="distractor-text">{{ label | translate }}</h4>
</div>

<div class="escape-message" *ngIf="authTimeout$ | async">
  <p translate>app.long-log-in-info</p>
  <a (click)="onEscapeAuth($event)" class="escape-link" translate>app.escape-authenticating</a>
</div>
